export default "__VITE_ASSET__af89dc00__"